import { useLocation } from "react-router-dom";
import {useState, useEffect } from "react";
import "./HamburgerButton.css";


export default function HamburgerButton ({ isOpen, onClick, noExtraClass }) {
  const location = useLocation();
  
  const [appliedLineClass, setAppliedLineClass] = useState("line");

  useEffect(() => {
    if (location.pathname.includes("/dashboard/invoices")) {
      setAppliedLineClass("line line-invoices");
    }else if( location.pathname.includes("/dashboard/inventory")) {
      setAppliedLineClass("line line-inventory");
    } else {
      setAppliedLineClass("line line-default");
    }
  }, [location.pathname]);

  return (
    <div className={`${!noExtraClass ? "hamburger-container shadow-drop-center" : ""} ${isOpen ? "expanded shadow-drop-center-rv" : ""}`}>
      <button
        className={`neomorphism-button menu-button hamburger-button ${isOpen ? "open" : ""}`}
        onClick={onClick}
      >
        <div className={appliedLineClass}></div>
        <div className={appliedLineClass}></div>
        <div className={appliedLineClass}></div>
      </button>
    </div>
  );
};
